var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-form"},[_c('div',{attrs:{"id":"card-number"}}),_vm._m(0),_c('div',{attrs:{"id":"card-error"}}),(_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"}),_c('p',[_vm._v("処理中です...")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{attrs:{"id":"card-expiry"}}),_c('div',{attrs:{"id":"card-cvc"}})])
}]

export { render, staticRenderFns }